import React, { useState } from "react";

import { useSelector } from "react-redux";

import { RootState } from "@/app/store";

import {
  ActiveModalNameEnum,
  BrandSoftwareTypeOption,
} from "@/features/ui/types";

import ReleasesControlPanel from "../components/ReleasesControlPanel/ReleasesControlPanel";
import GenericControlPanelModal from "../generic-control-panel/GenericControlPanelModal";

import { brandSoftwareOptions } from "../../constants";

interface DeviceModalProps {
  onHide: () => void;
}

const ReleasesControlPanelModal: React.FC<DeviceModalProps> = ({ onHide }) => {
  const [selectedOption, setSelectedOption] = useState<BrandSoftwareTypeOption>(
    brandSoftwareOptions[0]
  );

  const handleOnClickOption = (option: BrandSoftwareTypeOption) => {
    setSelectedOption(option);
  };

  const activeModalState = useSelector(
    (state: RootState) => state.ui.activeModalState
  );

  const { name } = activeModalState;

  const handleOnSuccess = () => onHide();

  return (
    <GenericControlPanelModal
      show={name === ActiveModalNameEnum.Release}
      onHide={onHide}
      leftPanelButtons={brandSoftwareOptions.filter(
        (option) => option.value !== "player"
      )}
      onClickLeftPanelButton={handleOnClickOption}
      selectedOption={selectedOption}
      rightPanelComponent={
        <ReleasesControlPanel
          onSuccess={handleOnSuccess}
          selectedOption={selectedOption}
        />
      }
    />
  );
};

export default ReleasesControlPanelModal;
